<template>
  <TresGroup />
</template>

<script setup lang="ts">
const props = defineProps({})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const { renderer } = useTresContext()

onMounted(() => {
  renderer.value.outputColorSpace = LinearSRGBColorSpace
  renderer.value.toneMapping = NoToneMapping
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>
